// extracted by mini-css-extract-plugin
export var siteTitle = "Navigation-module--siteTitle--kzgM2";
export var logoBox = "Navigation-module--logoBox--KGRV2";
export var logo = "Navigation-module--logo--N6Ez8";
export var copyright = "Navigation-module--copyright--DE+y+";